export const ANTICIPATION_RULE = "ANTICIPATION_RULE";
export const ANTICIPATION_TAX = "ANTICIPATION_TAX";
export const ACCOUNT_TAXES = "ACCOUNT_TAXES";
export const ACCOUNT_TAX_BRANDS = "ACCOUNT_TAX_BRANDS";
export const ACCOUNT_TAX_SELECTED_BRAND = "ACCOUNT_TAX_SELECTED_BRAND";
export const ACCOUNT_PAYERS = "ACCOUNT_PAYERS";
export const ACCOUNT_LENDS = "ACCOUNT_LENDS";
export const ANTICIPATIONS_AVAILABLE = "ANTICIPATIONS_AVAILABLE";
export const ANTICIPATIONS_AVAILABLE_COUNT = "ANTICIPATIONS_AVAILABLE_COUNT";
export const ANTICIPATIONS_AVAILABLE_LOADING = "ANTICIPATIONS_AVAILABLE_LOADING";
export const LOADING = "LOADING";
export const SELECTED_ANTICIPATIONS = "SELECTED_ANTICIPATIONS";
export const SELECTED_ANTICIPATIONS_AMOUNT = "SELECTED_ANTICIPATIONS_AMOUNT";
export const ANTICIPATIONS_AVAILABLE_LIMIT = "ANTICIPATIONS_AVAILABLE_LIMIT";
export const ANTICIPATIONS_AVAILABLE_PAGE = "ANTICIPATIONS_AVAILABLE_PAGE";
export const CURRENT_TAX = "CURRENT_TAX";
export const BALANCE = "BALANCE";
export const ACCOUNT = "ACCOUNT";
export const LOGO_LINK = "LOGO_LINK";
export const FAVICON = "FAVICON";
export const COLOR = "COLOR";
export const PARTNER_NAME = "PARTNER_NAME";
export const PARTNER_URL = "PARTNER_URL";
export const PARTNER = "PARTNER";
export const NOTIFICATIONS = "NOTIFICATIONS";
export const NOTIFICATIONS_VISIBLE = "NOTIFICATIONS_VISIBLE";
export const SHOW_LOGO_FORM = "SHOW_LOGO_FORM";
export const SHOW_FAVICON_FORM = "SHOW_FAVICON_FORM";
export const SHOW_COLOR_FORM = "SHOW_COLOR_FORM";
export const SHOW_FORM = "SHOW_URL_FORM";
export const NEW_LEND = "NEW_LEND";
export const NEW_LEND_STATUS = "NEW_LEND_STATUS";
export const NEW_LEND_ERROR = "NEW_LEND_ERROR";
export const ERRORS = "ERRORS";
export const SHOW_ERROR = "SHOW_ERROR";
export const SHOW_SUCCESS = "SHOW_SUCCESS";
export const ACTIVE_NEW = "ACTIVE_NEW";
export const IS_LOAD = "IS_LOAD";
export const IS_BILL_PAYMENT_ENABLED = "IS_BILL_PAYMENT_ENABLED";
export const IS_INVOICE_PAYMENT_ENABLED = "IS_INVOICE_PAYMENT_ENABLED";
export const IS_DARF_PAYMENT_ENABLED = "IS_DARF_PAYMENT_ENABLED";
export const IS_LINK_PAYMENT_ENABLED = "IS_LINK_PAYMENT_ENABLED";
export const IS_MANUAL_SALE_ENABLED = "IS_MANUAL_SALE_ENABLED";
export const IS_RECURRING_PAYMENT_ENABLED = "IS_RECURRING_PAYMENT_ENABLED";
export const IS_RECHARGE_ENABLED = "IS_RECHARGE_ENABLED";
export const SUCCESS_STATUS = "SUCCESS_STATUS";
export const ERROR_STATUS = "ERROR_STATUS";
export const SUCCESS_MESSAGE = "SUCCESS_MESSAGE";
export const ERROR_MESSAGE = "ERROR_MESSAGE";
export const LOAD = "LOAD";
